module.exports = __webpack_public_path__ + "img/L_321_324.7db312c7.png";